module.exports = __webpack_public_path__ + "static/img-serv-deploy-a4787c21257c02f8d8415c4f12139042.png";